@let id = servingCellId();

@if (id) {
  <div class="flex items-center gap-1 text-xs">
    <svg-icon [ngStyle]="{ color: color() }"
              class="shrink-0"
              src="icons/icon-cell-id.svg"
              name="icon-cell-id"></svg-icon>

    <span class="font-medium text-inherit truncate">{{ id }}</span>
  </div>
} @else {
  <span translate="@@shared-no-data-value-placeholder"></span>
}
